import { storeSrDebuggerInfo } from '@/features/sponsored-recommendations/helpers/sponsoredrec-debugging-tools';
import { storeUserGeoLocation } from '@/helpers/geo-location-helper';
import { storeNoIndexDebug } from '@/helpers/query-parameters-helper';
import { hasUCConsentBanner } from '@/helpers/tracking';
import { UsercentricsHelper } from '@/helpers/usercentrics-helper';
import { getUserCentricsConsentProfile } from '@/constants/user-centrics';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

export default defineNuxtPlugin({
	parallel: true,
	async setup() {
		await storeUserGeoLocation();

		if (hasUCConsentBanner(useLanguageStore().webLocale)) {
			UsercentricsHelper.preload(getUserCentricsConsentProfile()).catch(() => {});
		}

		storeSrDebuggerInfo();

		// temp solution to set debug params in session storage in meta.store
		storeNoIndexDebug();
		import('@/helpers/bundle-size-monitor').then(({ initBundleSizeMonitor }) => initBundleSizeMonitor());
	},
});
